import { enableStaticRendering } from 'mobx-react';
import AccaPublicTestResultStore from '@stores/AccaPublicTestResultStore';
import AccaTestResultStore from '@stores/AccaTestResultStore';
import InterviewPracticeStore from './InterviewPracticeStore';
import InterviewPracticeUIStore from './InterviewPracticeUIStore';
import { isServer } from '@utils/common';

// react hook 아님.
// eslint-disable-next-line react-hooks/rules-of-hooks
enableStaticRendering(isServer);

export interface Stores {
  accaTestResultStore: AccaTestResultStore;
  accaPublicTestResultStore: AccaPublicTestResultStore;
  interviewPracticeStore: InterviewPracticeStore;
  interviewPracticeUIStore: InterviewPracticeUIStore;
}

export function getStores(): Stores {
  return {
    accaTestResultStore: new AccaTestResultStore(),
    accaPublicTestResultStore: new AccaPublicTestResultStore(),
    interviewPracticeStore: new InterviewPracticeStore(),
    interviewPracticeUIStore: new InterviewPracticeUIStore(),
  };
}
